// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AiSuggestionsV2BannerGenerateMutationVariables = Types.Exact<{
  refreshInput: Types.RefreshHouseholdSuggestionsInput;
  householdID: Types.Scalars['ID']['input'];
}>;


export type AiSuggestionsV2BannerGenerateMutation = { __typename?: 'Mutation', refreshHouseholdSuggestions: boolean, updateHousehold: { __typename?: 'Household', id: string, showGenerateV2SuggestionsPrompt?: boolean | null } };

export const Operations = {
  Mutation: {
    AISuggestionsV2BannerGenerate: 'AISuggestionsV2BannerGenerate' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const AiSuggestionsV2BannerGenerateDocument = gql`
    mutation AISuggestionsV2BannerGenerate($refreshInput: RefreshHouseholdSuggestionsInput!, $householdID: ID!) {
  refreshHouseholdSuggestions(input: $refreshInput)
  updateHousehold(
    id: $householdID
    input: {showGenerateV2SuggestionsPrompt: false}
  ) {
    id
    showGenerateV2SuggestionsPrompt
  }
}
    `;
export type AiSuggestionsV2BannerGenerateMutationFn = Apollo.MutationFunction<AiSuggestionsV2BannerGenerateMutation, AiSuggestionsV2BannerGenerateMutationVariables>;

/**
 * __useAiSuggestionsV2BannerGenerateMutation__
 *
 * To run a mutation, you first call `useAiSuggestionsV2BannerGenerateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAiSuggestionsV2BannerGenerateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aiSuggestionsV2BannerGenerateMutation, { data, loading, error }] = useAiSuggestionsV2BannerGenerateMutation({
 *   variables: {
 *      refreshInput: // value for 'refreshInput'
 *      householdID: // value for 'householdID'
 *   },
 * });
 */
export function useAiSuggestionsV2BannerGenerateMutation(baseOptions?: Apollo.MutationHookOptions<AiSuggestionsV2BannerGenerateMutation, AiSuggestionsV2BannerGenerateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AiSuggestionsV2BannerGenerateMutation, AiSuggestionsV2BannerGenerateMutationVariables>(AiSuggestionsV2BannerGenerateDocument, options);
      }
export type AiSuggestionsV2BannerGenerateMutationHookResult = ReturnType<typeof useAiSuggestionsV2BannerGenerateMutation>;
export type AiSuggestionsV2BannerGenerateMutationResult = Apollo.MutationResult<AiSuggestionsV2BannerGenerateMutation>;
export type AiSuggestionsV2BannerGenerateMutationOptions = Apollo.BaseMutationOptions<AiSuggestionsV2BannerGenerateMutation, AiSuggestionsV2BannerGenerateMutationVariables>;